import { Component } from "@angular/core";
import { BaseComponent } from "../../../core/components/base.component";
import { SyncManagerButtonController } from "./sync-manager-button.controller";
import { SyncManagerButtonModel } from "./sync-manager-button.model";
import { VasAppFacade } from "../../services/vas-app-facade.service";
import { NavController } from "ionic-angular";

@Component({
    selector: "vas-sync-manager-button",
    templateUrl: "sync-manager-button.component.html",
    viewProviders: [
        {
            provide: SyncManagerButtonController,
            useClass: SyncManagerButtonController,
            deps: [
                VasAppFacade,
                NavController
            ]
        }
    ]
})
export class SyncManagerButtonComponent extends BaseComponent {

    protected model: SyncManagerButtonModel;

    constructor(
        protected controller: SyncManagerButtonController
    ) {
        super();
    }

    ngOnInit(): void {

        this.controller.model$
            .takeUntil(this.ngUnsubscribe)
            .subscribe(model => this.model = model);

        this.controller.ngOnInit();
    }

    get show(): boolean {
        return this.model ? this.model.show : false;
    }

    onClick(): void {
        this.controller.openSyncManager();
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-other/sync-manager-button/sync-manager-button.component.ts